import { MAIN_SLIDER_COMPANIES } from "../Permissions/companies";
import {
  MAIN_SLIDER_DASHBOARD,
  ROUTER_DASHBOARD,
} from "../Permissions/dashboard";
import { MAIN_SLIDER_USERS } from "../Permissions/users";
import { isMobile } from "react-device-detect";

export const PermissionsUI: { [key: string]: any } = {
  ROLE_USER: {
    LocalRouter: ROUTER_DASHBOARD,
    MainSlider: {
      info: MAIN_SLIDER_DASHBOARD,
    },
    companies: {
      info: MAIN_SLIDER_COMPANIES,
    },
    Dashboard: {
      info: MAIN_SLIDER_DASHBOARD,
    },
    Users: {
      info: MAIN_SLIDER_USERS,
    },
  },
};

//NAMES FOR EACH COMPONENT
export const componentNames = {
  LocalRouter: "LocalRouter",
  DinamicTabs: "DinamicTabs",
  VehicleOptions: "VehicleOptions",
  DinamicTabsServices: "DinamicTabsServices",
  MainTable: "MainTable",
  MainHeader: "MainHeader",
  VehicleMainInfo: "VehicleMainInfo",
  MainSlider: "MainSlider",
  VehiclesDashboard: "VehiclesDashboard",
  LoginPage: "LoginPage",
};


export const portraitLayout = window.matchMedia("(orientation: portrait)");

export const tableLayoutOnMobile =
isMobile && portraitLayout.matches ? "simple" : ("standard" as any);
